import { posthog } from "posthog-js";

import type { CopilotMeta } from "src/clients/agent-management";

/**
 * Diagnostics about this client: where the user was when they sent, and the
 * PostHog session whose replay shows what they were looking at. The backend
 * logs `meta` and drops it, so none of this reaches the model's context or
 * the session checkpoint.
 */
export const clientMeta = (): CopilotMeta => {
  // posthog is only initialized when keys exist and cookie consent allows it,
  // and yields an empty id until its session manager has loaded.
  const posthogSessionId = posthog.__loaded ? posthog.get_session_id() : "";
  return {
    client: "web",
    page_url: window.location.href,
    // Omitted rather than null so the log key is absent when there is no
    // replay to look up.
    ...(posthogSessionId ? { posthog_session_id: posthogSessionId } : {}),
  };
};
